import { UserAuthority } from './constants';

interface InitialState {
  currentUser: API.Service.UserDetail | null;
}

export default (initialState: InitialState) => {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // 参考文档 https://umijs.org/docs/max/access
  const isAdmin = !!(
    initialState &&
    initialState.currentUser !== null &&
    initialState.currentUser?.authority === UserAuthority.ADMINISTRATOR
  );
  return {
    isAdmin,
  };
};
